// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import ViewPepWatchReportPage from '../../components/PEP/ViewPepWatchReport';
interface IViewReport {
    id: string
}
const ViewPepWatchReport: React.FC<IViewReport> = ({
    id
}) => {
    return (
        <Entrypoint>
            <ViewPepWatchReportPage id={id} />
        </Entrypoint>
    );
}

export default ViewPepWatchReport;